export const languageCode = (slug: string) => {
  return 'de' === slug ? 'de' : 'gb'
}
